
const defaultConfig = {
    fnGetRequestDomain: () => {return DOMAIN.PROXY_API_ACTIVITY},
    fnGetWebSocketDomain: () => {return DOMAIN.WSS_URL_ACTIVITY},
    prefetchResources: {
        use: false,
        config: {
            count: 5
        }
    }
};

if(ENV === 'build' || ENV === 'build_dev') {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', DOMAIN.H5_CORS_STATIC + '/js/request-domain.v1.js', false);
    xhr.setRequestHeader('Cache-Control', 'max-age=0');
    xhr.onload = function (e) {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.text = xhr.responseText;
                document.head.appendChild(script);
            } else {
                console.error(`[${new Date().toLocaleString()}] - 获取请求域名 JS 文件失败！`, xhr.statusText);
                window.ACTIVITY_H5_CONFIG = defaultConfig
            }
        }
    };
    xhr.onerror = function (e) {
        console.error(`[${new Date().toLocaleString()}] - 获取请求域名 JS 文件失败！`, xhr.statusText);
    };
    xhr.send(null);
}
// 测试、本地直接使用本地配置
else {
    window.ACTIVITY_H5_CONFIG = defaultConfig;
}

